import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import React, { Suspense, useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordianDetail from "./AccordianDetail";
import AccordianDetailsV1 from "./AccordianDetailsV1";
import axios from "axios";
import { fcheck_null_undefine_replace_empty } from "../../../Utility/Utilitys";
import { getGlobals } from "../../../Configs";

const DetailComponent = ({
  countingDetail = [],
  setCountingDetail,
  vMediaQuery,
  fKeyTabInput = {},
  rowData = {},
  barcodeDetail = "",
}) => {
  const baseURL = getGlobals().API_BASE_URL;

  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const [isPanelLoaded, setIsPanelLoaded] = useState({});
  const [panelDataLoaded, setPanelDataLoaded] = useState({});

  const [isGridLoading, setIsGridLoading] = useState(false);

  const handleAccordionChange = (index) => {
    setExpandedAccordion((prevIndex) => (prevIndex === index ? null : index));

    // Mark the panel as loaded and trigger data fetch only if not loaded yet
    if (!panelDataLoaded[index]) {
      setIsGridLoading(true);
      setPanelDataLoaded((prev) => ({ ...prev, [index]: true })); //accodian toggle
    }

    setTimeout(() => {
      if (barcodeDetail !== "") {
        setTimeout(() => {
          const qtyInput = document.getElementById(`quantity-${index}`);
          if (qtyInput) qtyInput.focus();
        }, 400);
      } else {
        const barcodeInput = document.getElementById(`barcode-${index}`);
        if (barcodeInput) barcodeInput.focus();
      }
    }, 600);
  };

  useEffect(() => {
    if (!expandedAccordion || expandedAccordion !== null) {
      setIsGridLoading(true);
      console.log("expandedAccordion", expandedAccordion);
    }
  }, [expandedAccordion]);

  return (
    <Box>
      {countingDetail?.map((item, index) => (
        <Accordion
          key={index}
          className="accord"
          id={`accordion-${index}`}
          expanded={expandedAccordion === index}
          onChange={(event, isExpanded) => {
            handleAccordionChange(index); // external handler
            if (isExpanded && !isPanelLoaded[index]) {
              setIsPanelLoaded((prev) => ({ ...prev, [index]: true }));
            }
          }}
        >
          <AccordionSummary
            sx={{ backgroundColor: item.Qty > 0 ? "#d7f8e4 !important" : "" }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel-content-${index}`}
            id={`panel-header-${index}`}
          >
            <Grid container columnSpacing={vMediaQuery ? 0.5 : 0}>
              <Grid item xs={3} sm={2} md={2}>
                <Typography>{item.B_ItmCd}</Typography>
              </Grid>
              <Grid item xs={9} sm={5} md={5}>
                <Typography>{item.Item_Name}</Typography>
              </Grid>
              <Grid item xs={4} sm={2} md={2}>
                <Typography>{item.BarCode}</Typography>
              </Grid>
              <Grid item xs={7} sm={2} md={2}>
                <Typography>{item.Department}</Typography>
              </Grid>
              <Grid item xs={1} sm={1} md={1}>
                <Typography>{item.Qty}</Typography>
              </Grid>
            </Grid>
          </AccordionSummary>

          {isPanelLoaded[index] && (
            <AccordionDetails>
              <Suspense fallback={<p>Loading...</p>}>
                <AccordianDetailsV1
                  index={index}
                  item={item}
                  countingDetail={countingDetail}
                  setCountingDetail={setCountingDetail}
                  vMediaQuery={vMediaQuery}
                  fKeyTabInput={fKeyTabInput}
                  setIsPanelLoaded={setIsPanelLoaded}
                  rowData={rowData}
                  panelDataLoaded={panelDataLoaded[index]} // new prop
                  isGridLoading={isGridLoading}
                  setIsGridLoading={setIsGridLoading}
                  barcodeDetail={barcodeDetail}
                />
              </Suspense>
            </AccordionDetails>
          )}
        </Accordion>
      ))}
    </Box>
  );
};

export default DetailComponent;
